import React from 'react';
import { defaultSettings } from './default/settings';
const createPlugin = (settings) => {
    var _a, _b;
    const mergedSettings = Object.assign(Object.assign({}, defaultSettings), settings);
    const Controls = mergedSettings.Controls;
    return {
        controls: {
            type: 'custom',
            Component: (props) => (React.createElement(Controls, Object.assign({}, props, { translations: mergedSettings.translations }))),
        },
        Renderer: mergedSettings.Renderer,
        id: 'migeran/editor/core/content/sabeeapp',
        version: 1,
        icon: mergedSettings.icon,
        title: (_a = mergedSettings.translations) === null || _a === void 0 ? void 0 : _a.pluginName,
        isInlineable: true,
        description: (_b = mergedSettings.translations) === null || _b === void 0 ? void 0 : _b.pluginDescription,
    };
};
export default createPlugin;
//# sourceMappingURL=createPlugin.js.map